import React from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { UserInputWrapper, UserInputLabel, UserInputError } from './elements';
import {
  $gray,
  $secondaryFont,
  $gold,
} from '../../../styles';

const StyledTextarea = styled.textarea`
  border: solid 1px ${$gray};
  font-size: 1rem;
  font-family: ${$secondaryFont};
  padding: 0.75rem 1rem;
  border-radius: 4px;
  width: 100%;
  &:focus {
    outline-color: ${$gold};
  }
  min-height: 8rem;
  resize: vertical;
`;

const UserTextAreaInput = (props) => {
  const {
    placeholder,
    disabled,
    error,
    label,
    control,
    name,
    rules,
    className,
    onChange,
    defaultValue,
    type,
  } = props;
  const isRequired = rules && !!rules.required;
  return (
    <UserInputWrapper>
      { label && <UserInputLabel required={isRequired}>{ label }</UserInputLabel> }
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        render={({ onChange: controllerOnChange, value }) => (
          <StyledTextarea
            placeholder={placeholder}
            className={className}
            value={value}
            onChange={(selected) => {
              controllerOnChange(selected);
              if (onChange) {
                onChange(selected);
              }
            }}
            disabled={disabled}
            type={type}
            autoComplete="off"
            autoCorrect="off"
            spellCheck="off"
            autoCapitalize="off"
          />
        )}
      />
      { error && <UserInputError>{ error.message }</UserInputError> }
    </UserInputWrapper>
  );
};

UserTextAreaInput.propTypes = {
  placeholder: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  rules: PropTypes.shape({
    required: PropTypes.string,
  }),
  onChange: PropTypes.func,
  control: PropTypes.shape({}).isRequired, // Provided by react-hook-form, passed in via parent
  defaultValue: PropTypes.string,
  type: PropTypes.string,
};

UserTextAreaInput.defaultProps = {
  disabled: false,
  placeholder: null,
  className: null,
  error: null,
  label: null,
  rules: null,
  onChange: null,
  defaultValue: '',
  type: 'text',
};

export default UserTextAreaInput;
